// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__32FC2","label":"Radio_label__32795","checkMark":"Radio_checkMark__2Hyvm","disabled":"Radio_disabled__1o4VN"};